<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="ranking-container" v-show="!isHide">
    <div class="ranking-wrapper" :class="{'show-ranking': !rankingInterval}">
      <div class="ranking-list-title">
        <h5>실시간 인기 고시원</h5>
      </div>
      <div class="ranking-list-contents" v-if="$mq !== 'lg'">
        <transition-group name="slide-list" tag="ol" mode="out-in">
          <li v-for="(ranking, index) in rankingList" :key="`__RANKING__${index}`"
              @click="moveToDetail(ranking.kosiwon, index)" v-if="isShowList[index]">
            <span class="ranking">{{index+1}}</span>
            <span class="kosiwon-name">{{ranking.kosiwon.name}} {{ranking.kosiwon.branch}}</span>
          </li>
        </transition-group>
        <button class="ranking-toggle-btn" @click="toggleRankingView" :class="{open: isOpen}"></button>
      </div>
      <div class="ranking-list-contents" v-if="$mq === 'lg'">
        <ol>
          <li v-for="(ranking, index) in rankingList" :key="`__RANKING__${index}`"
              @click="moveToDetail(ranking.kosiwon, index)">
            <span class="ranking">{{index+1}}</span>
            <span class="kosiwon-name">{{ranking.kosiwon.name}} {{ranking.kosiwon.branch}}</span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicNavigator from '../../core/modules/DynamicNavigator'

  export default {
    name: 'RankingList',
    computed: {
      isHide() {
        return this.$store.state.RANKING_LIST.IS_HIDE
      }
    },
    data() {
      return {
        rankingList: [{
          kosiwon: {},
        }],
        isShowList: [true, false, false, false, false],
        isShowListIndex: 0,
        rankingInterval: undefined,
        isOpen: false
      }
    },
    methods: {
      async fetchRanking() {
        try {
          const rankingList = await this.axios.get('/ranking')
          this.rankingList = rankingList.data.result

          console.log(this.rankingList)
        } catch (error) {
          console.error(error)
        }
      },
      moveToDetail(kosiwon, index) {
        // ga('send', 'pageview');/**/
        
        if(window.gtag) {
          window.gtag('event', '버튼 클릭', {
            event_category: '랭킹',
            event_label: `랭킹 ${index+1}번 : ${kosiwon.name} ${kosiwon.branch}`
          })
        }

        let routeData = this.$router.resolve(`/detail/${kosiwon.pk}`)
        DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router)
        console.log(routeData)
      },
      openRankingView() {
        clearInterval(this.rankingInterval)
        this.rankingInterval = undefined
        for (let i = 0; i < this.isShowList.length; i++) {
          this.isShowList[i] = true
        }
        this.$forceUpdate()
      },
      resetRankingView() {
        if (!this.rankingInterval) {
          this.setRankingView()
          for (let i = 0; i < this.isShowList.length; i++) {
            this.isShowList[i] = i === this.isShowListIndex
          }
        }
      },
      toggleRankingView() {
        if (this.isOpen) {
          this.resetRankingView()
        } else {
          this.openRankingView()
        }
        this.isOpen = !this.isOpen
      },
      setRankingView() {
        this.rankingInterval = setInterval(() => {
          const curIndex = this.isShowList.indexOf(true)
          this.isShowList[curIndex] = false
          if (curIndex === this.isShowList.length - 1) {
            this.isShowListIndex = 0
          } else {
            this.isShowListIndex = curIndex + 1
          }
          this.isShowList[this.isShowListIndex] = true
          this.$forceUpdate()
        }, 4000)
      }
    },
    mounted() {
      this.fetchRanking()
      this.setRankingView()
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .ranking-wrapper {
    padding: 3.5rem;
    background-color: @white;
    opacity: 0.8;
    text-align: left;

    .ranking-list-title {
      padding: 0.65rem 0;
      border-bottom: 1px solid @brown-grey;

      h5 {
        font-size: 1.55rem;
        font-weight: bold;
      }
    }

    .ranking-list-contents {
      padding: 3rem 0;

      ol {
        list-style: decimal inside;
        counter-reset: item;

        li {
          padding: 1.5rem 0;
          display: block;
          cursor: pointer;

          span {
            &.kosiwon-name {
              margin: 0 2rem;
            }

            &.ranking {
              color: @windows-blue;
              font-weight: bold;
              font-size: 2rem;
            }
          }

          &:first-child {
            padding: 0 0 1.5rem;
          }

          &:last-child {
            padding: 1.5rem 0 0;
          }
        }
      }
    }
  }
</style>

<!-- Tablet Media Query -->
<style scoped lang="less">
  @import "../../assets/css/palette";

  @media screen and (max-width: 1366px) {
    .ranking-container {
      background-color: @white;

      .ranking-wrapper {
        max-width: 54rem;
        margin: 5.5rem auto 0;
        display: flex;
        text-align: center;
        justify-content: flex-start;
        padding: 0;
        opacity: 1;
        position: relative;
        z-index: 2;
        line-height: 5rem;
        overflow: hidden;

        &.show-ranking {
          overflow: initial;

          ol li.slide-list-enter-active, .slide-list-leave-active {
            transition: initial;
            opacity: 1;
          }

          ol li.slide-list-enter, .slide-list-leave-to {
            opacity: 1
          }
        }

        .ranking-list-title {
          border: 0;
          padding: 0;
          margin-right: 3.5rem;
          flex: 1;
        }

        .ranking-list-contents {
          padding: 0;
          margin-left: 3.5rem;
          flex: 2;
          position: relative;

          ol {
            text-align: left;
            position: absolute;
            padding: 0 1.5rem;
            background: @white;

            li {
              padding: 0;

              &:first-child, :last-child {
                padding: 0;
              }

              &.slide-list-enter-active, .slide-list-leave-active {
                transition: opacity .5s ease-in-out;
                opacity: 1;
              }

              &.slide-list-enter, .slide-list-leave-to {
                opacity: 0;
              }
            }
          }
          .ranking-toggle-btn {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            background: url('../../assets/images/ranking-open-btn@3x.png') no-repeat no-repeat center center;
            background-size: 1rem 0.75rem;
            &.open {
              background: url('../../assets/images/ranking-hide-btn@3x.png') no-repeat no-repeat center center;
              background-size: 1rem 0.75rem;
            }
          }
        }
      }

    }
  }
</style>


<style scoped lang="less">
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .ranking-container {
      .ranking-wrapper {
        margin: 1rem auto 0;
        padding: 0 1rem;
        .ranking-list-title {
          margin: 0;
        }

        .ranking-list-contents {
          margin: 0;
        }
      }
    }
  }
</style>

